// frontend/src/screens/EditDeveloperScreen.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSingleDeveloper,
  updateDeveloper,
} from "../actions/developerActions";
import {
  DEVELOPER_UPDATE_RESET,
  DEVELOPER_DETAILS_RESET,
} from "../constants/developerConstants";

const EditDeveloperScreen = () => {
  const { developerId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Local state
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // developerDetails slice
  const developerDetails = useSelector((state) => state.developerDetails);
  const {
    loading: detailsLoading,
    error: detailsError,
    developer,
  } = developerDetails;

  // developerUpdate slice
  const developerUpdate = useSelector((state) => state.developerUpdate);
  const {
    loading: updateLoading,
    error: updateError,
    developerUpdateSuccess,
  } = developerUpdate;

  useEffect(() => {
    // If we don't have the developer or have the wrong one
    if (!developer || developer._id !== developerId) {
      dispatch(getSingleDeveloper(developerId));
    } else {
      // pre-fill local fields from the store
      setName(developer.name || "");
      setEmail(developer.email || "");
      // password remains blank unless changed
    }
  }, [dispatch, developer, developerId]);

  // On success, navigate + reset leftover flags
  useEffect(() => {
    if (developerUpdateSuccess) {
      navigate("/admin-dashboard");
      dispatch({ type: DEVELOPER_UPDATE_RESET });
      dispatch({ type: DEVELOPER_DETAILS_RESET }); // if you want to clear out old data
    }
  }, [developerUpdateSuccess, dispatch, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // If password is optional, only pass it if the user filled it in
    dispatch(
      updateDeveloper(developerId, {
        name,
        email,
        password,
      })
    );
  };

  return (
    <div>
      <h2>Edit Developer Info (ID: {developerId})</h2>
      {detailsError && <p style={{ color: "red" }}>{detailsError}</p>}
      {updateError && <p style={{ color: "red" }}>{updateError}</p>}
      {(detailsLoading || updateLoading) && <p>Loading...</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <label>Developer Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label>Developer Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label>New Password (optional):</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit">Update Developer</button>
      </form>
    </div>
  );
};

export default EditDeveloperScreen;
